import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DEFAULT_BOOKINGCHANNEL, DEFAULT_MULTI_SEARCH_ROOM } from '@whitbread-eos/api';
import { SORT_TYPES, NEW_PI_SORT_TYPES, NEW_BB_SORT_TYPES } from '@whitbread-eos/molecules';
import { isDateValid, getTodayTomorrowDate, MAX_ROOMS_SEARCH_LIMIT } from '@whitbread-eos/utils';
import { format } from 'date-fns';
import set from 'lodash/set';
export function mapSearchParamsForURL(params) {
  var _params$rooms;
  var roomsInputDataMapped = params === null || params === void 0 || (_params$rooms = params.rooms) === null || _params$rooms === void 0 ? void 0 : _params$rooms.map((room, idx) => {
    return {
      ["ADULT".concat(idx + 1)]: room.adults,
      ["CHILD".concat(idx + 1)]: room.children,
      ["COT".concat(idx + 1)]: room.shouldIncludeCot ? 1 : 0
    };
  });
  var roomInputDataObj = roomsInputDataMapped === null || roomsInputDataMapped === void 0 ? void 0 : roomsInputDataMapped.reduce((prev, current) => _objectSpread(_objectSpread({}, prev), current), {});
  return _objectSpread(_objectSpread({}, params), roomInputDataObj);
}
export function setSearchLocationInLocalStorage(queryParams, stayDetailsState) {
  var placeId = queryParams !== null && queryParams !== void 0 && queryParams.placeId ? queryParams.placeId : '';
  var location = queryParams !== null && queryParams !== void 0 && queryParams.location ? {
    longitude: queryParams.location[0],
    latitude: queryParams.location[1]
  } : {
    longitude: '',
    latitude: ''
  };
  var hotelId = queryParams !== null && queryParams !== void 0 && queryParams.code ? queryParams.code : '';
  set(stayDetailsState.data.info, 'suggestion.placeId', placeId);
  set(stayDetailsState.data.info, 'suggestion.location', location);
  return set(stayDetailsState.data.info, 'suggestion.hotelId', hotelId);
}
export function mapRoomsForAvailabilityQuery(rooms, mappedRoomLabels) {
  return rooms.map(room => {
    var roomCode = mappedRoomLabels[room.roomType];
    return {
      adultsNumber: room.adults,
      childrenNumber: room.children,
      roomType: roomCode,
      cotRequired: room.shouldIncludeCot
    };
  });
}
export function formatSummaryDateRange(dateFormat, startDate, endDate, translationDateLanguage) {
  if (!startDate || !endDate) {
    return;
  }
  return "".concat(format(startDate, dateFormat, translationDateLanguage), " - ").concat(format(endDate, dateFormat, translationDateLanguage));
}
export var getNotificationMarginTop = (searchSummaryActive, searchConsoleIsActive, breakPoint) => {
  var isMobile = breakPoint === 'mobile';
  if (searchSummaryActive) {
    return 'md';
  }
  if (searchConsoleIsActive) {
    return isMobile ? '-11rem' : '-xl';
  }
  return isMobile ? '-7rem' : '-2xl';
};
export function getRedirectWithDefaultsURL(router, day, month, year, NIGHTS, showMultipleRooms, isPriceFinderPage) {
  var defaultQuery = _objectSpread({
    ARRdd: day,
    ARRmm: month,
    ARRyyyy: year
  }, !isPriceFinderPage && {
    NIGHTS: !showMultipleRooms ? 1 : NIGHTS,
    ROOMS: 1,
    ADULT1: 1,
    CHILD1: 0,
    COT1: 0,
    INTTYP1: 'DB'
  });
  var _router$asPath$split = router.asPath.split('?'),
    _router$asPath$split2 = _slicedToArray(_router$asPath$split, 2),
    path = _router$asPath$split2[0],
    searchParams = _router$asPath$split2[1];
  var shouldKeepKey = key => {
    return !(Object.keys(defaultQuery).includes(key) || key.startsWith('ADULT') || key.startsWith('CHILD') || key.startsWith('INTTYP') || key.startsWith('COT'));
  };
  var url = new URLSearchParams(searchParams);
  var newQueryParams = Array.from(url.entries()).filter(_ref => {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return shouldKeepKey(key);
  }).reduce((query, _ref3) => {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    query[key] = value;
    return query;
  }, defaultQuery);
  var newSearchParams = Object.entries(newQueryParams).map(_ref5 => {
    var _ref6 = _slicedToArray(_ref5, 2),
      key = _ref6[0],
      value = _ref6[1];
    return "".concat(key, "=").concat(value);
  }).join('&');
  return "".concat(path, "?").concat(newSearchParams);
}
export function appendPromoIdToUrl(baseUrl, promoId) {
  if (promoId) {
    return "".concat(baseUrl, "&PROMOID=").concat(promoId);
  }
  return baseUrl;
}
export function getSearchParams(query, isMetaArrivalDayKeywordFlagEnabled, enabledNewSortOrderDropdown) {
  var _SORT_TYPES$Number;
  var NIGHTS = query.NIGHTS,
    ROOMS = query.ROOMS,
    LOCATION = query.LOCATION,
    PLACEID = query.PLACEID,
    BOOKINGCHANNEL = query.BOOKINGCHANNEL,
    FILTERS = query.FILTERS,
    CODE = query.CODE,
    PROMOID = query.PROMOID;
  var ARRdd = query.ARRdd,
    ARRmm = query.ARRmm,
    ARRyyyy = query.ARRyyyy;
  if (isMetaArrivalDayKeywordFlagEnabled) {
    var updatedArrivalDate = getTodayTomorrowDate(ARRdd, ARRmm, ARRyyyy);
    if (updatedArrivalDate) {
      ARRdd = updatedArrivalDate.ARRdd;
      ARRmm = updatedArrivalDate.ARRmm;
      ARRyyyy = updatedArrivalDate.ARRyyyy;
    }
  }
  var location = query['searchModel.searchTerm'];
  var SORT = query === null || query === void 0 ? void 0 : query.SORT;
  var CELLCODES = query === null || query === void 0 ? void 0 : query.CELLCODES;
  var cellCodesArr = CELLCODES === null || CELLCODES === void 0 ? void 0 : CELLCODES.split(',');
  var sort = (_SORT_TYPES$Number = SORT_TYPES[Number(SORT)]) !== null && _SORT_TYPES$Number !== void 0 ? _SORT_TYPES$Number : SORT_TYPES[1];
  if (enabledNewSortOrderDropdown !== null && enabledNewSortOrderDropdown !== void 0 && enabledNewSortOrderDropdown.isPiSortOrderDropdownEnabled) {
    var _NEW_PI_SORT_TYPES$Nu;
    sort = (_NEW_PI_SORT_TYPES$Nu = NEW_PI_SORT_TYPES[Number(SORT)]) !== null && _NEW_PI_SORT_TYPES$Nu !== void 0 ? _NEW_PI_SORT_TYPES$Nu : NEW_PI_SORT_TYPES[1];
  } else if (enabledNewSortOrderDropdown !== null && enabledNewSortOrderDropdown !== void 0 && enabledNewSortOrderDropdown.isBbSortOrderDropdownEnabled) {
    var _NEW_BB_SORT_TYPES$Nu;
    sort = (_NEW_BB_SORT_TYPES$Nu = NEW_BB_SORT_TYPES[Number(SORT)]) !== null && _NEW_BB_SORT_TYPES$Nu !== void 0 ? _NEW_BB_SORT_TYPES$Nu : NEW_BB_SORT_TYPES[1];
  }
  var corpId = query.CORPID && query.CORPID;
  var compId = query.COMPID && query.COMPID;
  var SRRooms = [];
  for (var idx = 0; idx < Number(ROOMS) && idx < MAX_ROOMS_SEARCH_LIMIT; idx++) {
    var room = {
      adultsNumber: Number(query["ADULT".concat(idx + 1)]),
      childrenNumber: Number(query["CHILD".concat(idx + 1)]),
      type: query["INTTYP".concat(idx + 1)]
    };
    SRRooms.push(room);
  }
  if (SRRooms.length === 0) {
    SRRooms.push(DEFAULT_MULTI_SEARCH_ROOM);
  }
  var isArrivalValid = isDateValid(Number(ARRdd), Number(ARRmm), Number(ARRyyyy));
  var multiSearchParams = {
    arrivalDay: isArrivalValid ? Number(ARRdd) : null,
    arrivalMonth: isArrivalValid ? Number(ARRmm) : null,
    arrivalYear: isArrivalValid ? Number(ARRyyyy) : null,
    location: location,
    numberOfNights: isArrivalValid ? Number(NIGHTS) : null,
    rooms: SRRooms,
    code: CODE,
    placeId: PLACEID,
    coordinates: LOCATION,
    bookingChannel: BOOKINGCHANNEL ? BOOKINGCHANNEL : DEFAULT_BOOKINGCHANNEL,
    sort: sort,
    filters: FILTERS || '',
    cellCodes: cellCodesArr,
    corpId,
    compId,
    promoId: PROMOID
  };
  return multiSearchParams;
}
export var FIELDS = {
  datepicker: 'datepicker',
  location: 'location',
  occupancy: 'occupancy',
  numberOfNights: 'numberOfNights'
};
export var ERROR_KEYS = {
  invalidLocation: 'invalidLocation',
  invalidDate: 'invalidDate',
  arrivalDateInThePast: 'arrivalDateInThePast',
  arrivalDateInTheFuture: 'arrivalDateInTheFuture',
  invalidNights: 'invalidNights',
  invalidOccupancy: 'invalidOccupancy'
};
export var ERROR_FIELDS = {
  invalidLocation: 'location',
  invalidDate: 'datepicker',
  arrivalDateInThePast: 'datepicker',
  arrivalDateInTheFuture: 'datepicker',
  invalidNights: 'numberOfNights',
  invalidOccupancy: 'occupancy'
};